// TODO: Rework this class to use static methods
// and Big.js for money calculations.
import Big from "big.js";

export default class Margin {
  constructor(vat, purchasingPrice, rrp) {
    this.vat =
      typeof(vat) === "undefined" || vat === null ? Big(0) : Big(vat);
    this.purchasingPrice =
      typeof(purchasingPrice) === "undefined" || purchasingPrice === null ? Big(0) : Big(purchasingPrice);
    this.rrp =
      typeof(rrp) === "undefined" || rrp === null ? Big(0) : Big(rrp);
  }

  margin() {
    if (this.vat.eq(0)) {
      return Big(0);
    }

    const netRRP = this.netRRP();
    const absMargin = this.absMargin();

    if (netRRP.eq(0) || absMargin.eq(0)) {
      return Big(0);
    }

    return absMargin
      .div(netRRP)
      .mul(100);
  }

  absMargin() {
    const netRRP = this.netRRP();

    if (netRRP.eq(0) || this.purchasingPrice.eq(0)) {
      return Big(0);
    }
    return netRRP.minus(this.purchasingPrice);
  }

  netRRP() {
    if (this.rrp.eq(0) || this.vat.eq(0)) {
      return Big(0);
    }

    return this.rrp.div(
      this.vat
        .div(100)
        .plus(1)
    );
  }

  marginFormatted() {
    const margin = this.margin();
    if (margin.eq(0)) {
      return "- %";
    }

    return `${margin.toFixed(0)}%`;
  }

  highlightColor() {
    return this.margin().gte(35) ? "highlight" : "";
  }
}
